import type { IProduct } from './product';

/**
 * @deprecated
 * These packages will not be sold past 2024 Q1 */
export enum EDeprecatedPackages {
  Finch = 'Finch',
  FinchLicense = 'Finch License',
  FinchLicenseExtended = 'Finch License - Extended',
  FinchLegacy = 'Finch Legacy',
  FinchLegacyLicense = 'Finch Legacy License',
  Falcon = 'Falcon',
  FalconLicense = 'Falcon License',
  FalconLicenseExtended = 'Falcon License - Extended',
  Phoenix = 'Phoenix',
  PhoenixLicense = 'Phoenix License',
  PhoenixLicenseExtended = 'Phoenix License - Extended',
  EnterpriseMarketingSeat = 'Enterprise Marketing Seat',
  EnterpriseUnlimitedMarketingSeats = 'Enterprise Unlimited Marketing Seats',
  EnterpriseMonetizationSeat = 'Enterprise Monetization Seat',
  EnterpriseUnlimitedMonetizationSeats = 'Enterprise Unlimited Monetization Seats',
  EnterpriseFalcon = 'Enterprise Falcon',
  EnterpriseFalconSeat = 'Enterprise Falcon Seat',
  EnterpriseFalconUnlimitedSeats = 'Enterprise Falcon Unlimited Seats',
  EnterpriseFlamingo = 'Enterprise Flamingo',
}

export enum EPackages {
  /*
   * The new license packages from 2024 Q1 onwards.
   */
  FeathrPlatformLite = 'Feathr Platform - Lite',
  FeathrPlatformBase = 'Feathr Platform - Base',
  /** Feathr Platform - Starter deviates from the package naming convention due to a clerical error on the product change form signed on 15 Oct 2024. */
  FeathrPlatformStarter = 'Feathr Starter',
  FeathrPlatformEssential = 'Feathr Platform - Essential',
  FeathrPlatformEssentialPro = 'Feathr Platform - Essential Pro',
  FeathrPlatformAdvanced = 'Feathr Platform - Advanced',
  FeathrPlatformAdvancedPro = 'Feathr Platform - Advanced Pro',
  FeathrPlatformEnterprise = 'Feathr Platform - Enterprise',
  FeathrPlatformEnterprisePro = 'Feathr Platform - Enterprise Pro',

  /** "Internal" package grants unrestricted access to all features. PROCEED WITH CAUTION */
  Internal = 'Internal',

  /*
   * These will not be sold past 2024 Q1. After that, they will expire and must
   * be migrated to the new license model.
   *
   * The following are deprecated and should not be used.
   */
  /** @deprecated */
  Finch = EDeprecatedPackages.Finch,
  /** @deprecated */
  FinchLegacy = EDeprecatedPackages.FinchLegacy,
  /** @deprecated */
  Phoenix = EDeprecatedPackages.Phoenix,
  /** @deprecated */
  FalconLicenseExtended = EDeprecatedPackages.FalconLicenseExtended,
  /** @deprecated */
  FinchLicenseExtended = EDeprecatedPackages.FinchLicenseExtended,
  /** @deprecated */
  PhoenixLicenseExtended = EDeprecatedPackages.PhoenixLicenseExtended,
  /** @deprecated */
  EnterpriseMarketingSeat = EDeprecatedPackages.EnterpriseMarketingSeat,
  /** @deprecated */
  EnterpriseUnlimitedMarketingSeats = EDeprecatedPackages.EnterpriseUnlimitedMarketingSeats,
  /** @deprecated */
  EnterpriseMonetizationSeat = EDeprecatedPackages.EnterpriseMonetizationSeat,
  /** @deprecated */
  EnterpriseUnlimitedMonetizationSeats = EDeprecatedPackages.EnterpriseUnlimitedMonetizationSeats,
  /** @deprecated */
  Falcon = EDeprecatedPackages.Falcon,
  /** @deprecated */
  EnterpriseFlamingo = EDeprecatedPackages.EnterpriseFlamingo,
  /** @deprecated */
  EnterpriseFalcon = EDeprecatedPackages.EnterpriseFalcon,
  /** @deprecated */
  EnterpriseFalconSeat = EDeprecatedPackages.EnterpriseFalconSeat,
  /** @deprecated */
  EnterpriseFalconUnlimitedSeats = EDeprecatedPackages.EnterpriseFalconUnlimitedSeats,
  /** @deprecated */
  FalconLicense = EDeprecatedPackages.FalconLicense,
  /** @deprecated */
  FinchLicense = EDeprecatedPackages.FinchLicense,
  /** @deprecated */
  FinchLegacyLicense = EDeprecatedPackages.FinchLegacyLicense,
  /** @deprecated */
  PhoenixLicense = EDeprecatedPackages.PhoenixLicense,
}

export enum EPackageItemIds {
  Finch = 'I_101',
  FinchLegacy = 'I_104',
  Falcon = 'I_102',
  EnterpriseFlamingo = 'I_201',
  EnterpriseFalcon = 'I_202',
  Phoenix = 'I_103',
  FeathrPlatformLite = 'I_121',
  FeathrPlatformEssential = 'I_108',
  FeathrPlatformEssentialPro = 'I_109',
  FeathrPlatformAdvanced = 'I_111',
  FeathrPlatformAdvancedPro = 'I_112',
  FeathrPlatformEnterprise = 'I_116',
  FeathrPlatformEnterprisePro = 'I_117',
  FeathrPlatformBase = 'I_118',
  FeathrPlatformStarter = 'I_119',
}

export enum EPackageTiers {
  // Legacy Package Tier
  Finch = 'Finch',
  Falcon = 'Falcon',
  EnterpriseFalcon = 'Enterprise Falcon',
  Phoenix = 'Phoenix',

  // Platform Package Tier
  Lite = 'Lite',
  Base = 'Base',
  Starter = 'Starter',
  Essential = 'Essential',
  Advanced = 'Advanced',
  Enterprise = 'Enterprise',
}

export interface IPackage extends IProduct {
  name: EPackages;
  item_id: EPackageItemIds;
}

export const {
  FeathrPlatformLite: lite,
  FeathrPlatformBase: base,
  FeathrPlatformStarter: starter,
  FeathrPlatformEssential: essential,
  FeathrPlatformEssentialPro: essentialPro,
  FeathrPlatformAdvanced: advanced,
  FeathrPlatformAdvancedPro: advancedPro,
  FeathrPlatformEnterprise: enterprise,
  FeathrPlatformEnterprisePro: enterprisePro,
  Internal: internal,
  Finch: finch,
  FinchLicense: finchLicense,
  FinchLegacy: finchLegacy,
  FinchLegacyLicense: finchLegacyLicense,
  Falcon: falcon,
  Phoenix: phoenix,
  PhoenixLicense: phoenixLicense,
  EnterpriseFalcon: enterpriseFalcon,
  EnterpriseFlamingo: enterpriseFlamingo,
  FalconLicense: falconLicense,
  FalconLicenseExtended: falconLicenseExtended,
  FinchLicenseExtended: finchLicenseExtended,
  PhoenixLicenseExtended: phoenixLicenseExtended,
  EnterpriseMarketingSeat: enterpriseMarketingSeat,
  EnterpriseUnlimitedMarketingSeats: enterpriseUnlimitedMarketingSeats,
} = EPackages;
